interface LoadingSpinnerProps {
  size?: "sm" | "md" | "lg";
  message?: string;
}

export default function LoadingSpinner({ size = "md", message = "Loading..." }: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: "h-4 w-4",
    md: "h-8 w-8",
    lg: "h-12 w-12"
  };

  return (
    <div className="min-h-screen bg-replit-bg flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div className={`animate-spin rounded-full border-2 border-replit-primary border-t-transparent ${sizeClasses[size]}`}></div>
        {message && (
          <p className="text-replit-text-secondary text-sm">{message}</p>
        )}
      </div>
    </div>
  );
}